import React, {PropTypes} from 'react'
import t from 'tcomb-form'
import {EmailRefinement} from '../utils/tcomb-utils'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {doLoginUser, doFBLogin} from '../actions'
import FacebookLoginButton from './FacebookLoginButton'
import settings from '../settings'

const formSchema = t.struct({
  email: EmailRefinement,
  password: t.String,
  remember_me: t.Boolean,
  next: t.maybe(t.String)
})

const formOptions = {
  auto: 'none',
  fields: {
    email: {
      type: 'email',
      error: 'Please provide a valid email address',
      attrs: {
        placeholder: 'Email'
      }
    },
    password: {
      error: 'Password cannot be empty',
      type: 'password',
      attrs: {
        placeholder: 'Password'
      }
    },
    remember_me: {
      type: 'boolean',
      label: 'Remember me',
      attrs: {
        className: "join-remember_me"
      }
    },
    next: {
      type: 'hidden'
    }
  }
}

function mapStateToProps(state) {
  return {
    loginAttempts: state.auth.loginAttempts,
    user: state.auth.user,
  }
}


@connect(mapStateToProps, {doLoginUser, doFBLogin})
class LoginForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formValue: {},
      formOptions,
    }
  }

  onFormChange = formValue => {
    this.setState({ formValue })
  }


  login = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const value = this.refs.loginForm.getValue()
    console.info('formValue===>l', value)
    if (value) {
      this.props.doLoginUser(value)
    }
  }

  componentWillMount() {
  }

  componentDidMount() {
    console.info(this.props)
    const { payload } = this.props
    this.setState({formValue: { next: payload.next }})
  }

  componentWillReceiveProps(nextProps) {
    const { payload } = nextProps
    this.setState({formValue: { next: payload.next }})
  }

  componentWillUnmount() {
  }

  render() {
    const {user, loginAttempts, signup} = this.props

    let loginError = ''
    if (loginAttempts > 0) {
      loginError = <p className="form-error">
        <strong>Log in failed!</strong> Email and/or password did not match any in our database.
      </p>
    } else if (signup.error) {
      // In case of fb signup fails.
      loginError = <p className="form-error">
        {signup.message}
      </p>
    } else {
      loginError = ''
    }

    return (
      <form className="loginForm" onSubmit={this.login}>
        <h1 className="loginFormHeading" style={{fontSize: "3.8rem"}}>Already a member? Log In</h1>
        {loginError}
        <t.form.Form ref="loginForm"
                     value={this.state.formValue}
                     onChange={this.onFormChange}
                     type={formSchema}
                     options={this.state.formOptions}/>
        <button onClick={this.login} className="button button-primary" style={{display: 'block', width: '100%'}}
                type="submit">Log in
        </button>
        
      </form>
    )
  }

}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm.jsx